export default "__VITE_ASSET__Bj98W17E__"